<div class="voucher-item d-flex h-100" (click)="popupDetail(voucher)">
    <div class="d-flex flex-column gap-1 text-center discount">
        <span style="font-size: 12px; font-weight: 600; color: #444444; word-break: break-all;">#{{voucher.code}}</span>
        <ng-container *ngIf="voucher.discountType == discountType.Percentage">
            <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">Chiết
                khẩu</span>
            <span class="discount-value">{{voucher.discountValue}}%</span>
            <span *ngIf="voucher.maximumAmount"
                style="font-size: 14px; font-weight: 600; color: #000000; line-height: 100%;">tối đa
                {{voucher.maximumAmount | currencySymbol}}</span>
        </ng-container>
        <ng-container *ngIf="voucher.discountType == discountType.FixedAmount">
            <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">Giảm</span>
            <span class="discount-value">{{voucher.discountValue | currencySymbol}}</span>
        </ng-container>
        <ng-container *ngIf="voucher.discountType == discountType.Coin">
            <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">Hoàn</span>
            <span class="discount-value">{{voucher.discountValue | currencySymbol: false}} xu</span>
        </ng-container>
    </div>
    <div class="divider">
        <div class="top"></div>
        <div class="short short-1"></div>
        <div class="long long-2"></div>
        <div class="long long-3"></div>
        <div class="short short-4"></div>
        <div class="bottom"></div>
    </div>
    <div class="voucher-info-container w-100 h-100">
        <div class="voucher-info">
            <div class="voucher-info-tag">
                <div class="voucher-tags">
                    <div *ngFor="let tag of voucher.tags" class="tag">{{tag.name}}</div>
                </div>
                <div class="voucher-quantity">x{{voucher.remainingUses > 99 ?
                    '99+' : voucher.remainingUses}}</div>
            </div>
            <!-- <span class="voucher-title">{{voucher.titleVoucher}}</span> -->
            <span class="voucher-description">{{voucher.descriptionVoucher}}</span>
            <!-- <span *ngIf="voucher.remainingQuantity !== undefined && voucher.remainingQuantity !== null" class="global-quota" style="font-size: 13px; color: #ff8e00;">
                Còn <span class="bold">{{voucher.remainingQuantity}}</span> lượt toàn hệ thống
            </span> -->
            <span class="expire-date">
                HSD: <span class="bold">{{voucher.conditions?.end | date: 'dd/MM/yyyy'}}</span>
            </span>
            <span *ngIf="errorMessage" class="voucher-error-msg">{{errorMessage}}</span>
        </div>
        <div class="action-container">
            <!-- <span class="d-none d-lg-block d-xl-block d-xxl-block expire-date">
                HSD: <span class="bold">{{voucher.conditions?.end | date: 'dd/MM/yyyy'}}</span>
            </span> -->
            <!-- <div class="d-block d-lg-none d-xl-none d-xxl-none voucher-quantity">x{{voucher.remainingUses > 99 ? '99+' :
                voucher.remainingUses}}</div> -->

            <div *ngIf="!isCheckout" class="view-detail">
                <span style="font-size: 14px; line-height: 120%;">Xem chi tiết</span>
                <img src="assets/svg/voucher/chevron-forward.svg" style="width: 16px; height: 16px;"  loading="lazy" />
            </div>

            <ng-container *ngIf="isCheckout">
                <div *ngIf="!voucher.isApplied && voucher.isApplicable && voucher.remainingQuantity !== 0" class="view-detail apply" (click)="onApplyVoucher($event, voucher)" data-cta="voucher.use_now" data-cta-loc="voucher">
                    <span style="font-size: 14px; line-height: 120%;">Sử dụng ngay</span>
                </div>

                <div *ngIf="voucher.isApplied" class="view-detail applied" (click)="onApplyVoucher($event, voucher)">
                    <img src="assets/svg/voucher/check.svg" style="width: 16px; height: 16px;"  loading="lazy" />
                    <span style="font-size: 14px; line-height: 120%;">Đã áp dụng</span>
                </div>

                <div *ngIf="voucher.remainingQuantity === 0 && !voucher.isApplied" class="view-detail disabled" (click)="$event.stopPropagation()">
                    <span style="font-size: 14px; line-height: 120%;">Đã hết lượt</span>
                </div>

                <div *ngIf="!voucher.isApplied && !voucher.isApplicable && voucher.remainingQuantity !== 0" class="view-detail disabled" (click)="$event.stopPropagation()">
                    <span style="font-size: 14px; line-height: 120%;">Chưa đủ điều kiện</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<app-voucher-detail-modal #detailModal [selectedVoucher]="voucher" (closeModalEvent)="closeModal()"></app-voucher-detail-modal>
